import { Box, Text } from '@chakra-ui/react'

export const DashboardNotFound = () => (
    <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
        bg="gray.50"
        borderRadius="md"
        shadow="sm"
        padding="6"
        textAlign="center"
    >
        <Text fontSize="xl" fontWeight="bold">
            As informações dos dashboards não foram encontradas.
        </Text>
    </Box>
)
